import type { ScanShape } from '@/types'

export type ScanHole = {
    x: number
    y: number
    w: number
    h: number
}

const RECTANGLE_ASPECT_RATIO = 295 / 850
const RECTANGLE_WIDTH_RATIO = 0.6
const ROUND_BASE_WIDTH_RATIO = 0.55
const CIRCLE_SCALE_DOWN = 1.25
const SQUARE_SCALE_DOWN = 1.5

export function calculateScanHole(
    overlayWidth: number,
    overlayHeight: number,
    shape: ScanShape
): ScanHole {
    const baseW = Math.round(overlayWidth * RECTANGLE_WIDTH_RATIO)
    const roundBaseW = Math.round(overlayWidth * ROUND_BASE_WIDTH_RATIO)

    const holeW =
        shape === 'rectangle'
            ? baseW
            : shape === 'circle'
              ? Math.round(roundBaseW / CIRCLE_SCALE_DOWN)
              : Math.round(roundBaseW / SQUARE_SCALE_DOWN)
    const holeH = shape === 'rectangle' ? Math.round(baseW * RECTANGLE_ASPECT_RATIO) : holeW

    const innerLeft = (overlayWidth - holeW) / 2
    const innerTop = (overlayHeight - holeH) / 2
    const innerRight = innerLeft + holeW
    const innerBottom = innerTop + holeH

    return {
        x: Math.max(0, innerLeft),
        y: Math.max(0, innerTop),
        w: Math.max(0, Math.min(overlayWidth, innerRight) - Math.max(0, innerLeft)),
        h: Math.max(0, Math.min(overlayHeight, innerBottom) - Math.max(0, innerTop)),
    }
}
